import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Link from 'ui-library/Link';

import {ErrorMessage, SuccessMessage, Warning} from '../../BulkWorkflowComponents';
import {GibsonStatus, LocalAssembly} from '../BulkAssemblyConstants';
import {isGibsonAssembly} from '../BulkAssemblyUtil';

interface Props {
  assembly: LocalAssembly;
  slotIdx: number;
  onOpenPrimerSettings: () => void;
}

export default function GibsonPrimerSummary(props: Props): JSX.Element | null {
  const {assembly, onOpenPrimerSettings, slotIdx} = props;
  if (!isGibsonAssembly(assembly) || !assembly.meta.summary) {
    return null;
  }
  const gibsonStatus = assembly.meta.summary.slots[slotIdx]?.gibsonStatus;
  switch (gibsonStatus) {
    case GibsonStatus.UNFINALIZED: {
      return null;
    }
    case GibsonStatus.SUCCESS: {
      return (
        <div className={css(styles.messageContainer)}>
          <SuccessMessage>Gibson primers have been finalized for this slot.</SuccessMessage>
        </div>
      );
    }
    case GibsonStatus.PENDING_ADJACENT: {
      return (
        <div className={css(styles.messageContainer)}>
          <Warning>The validation of Gibson primers is pending the finalization of adjacent slot(s).</Warning>
        </div>
      );
    }
    case GibsonStatus.FAILURE: {
      return (
        <div className={css(styles.messageContainer)}>
          <ErrorMessage>
            No Gibson primers could be found. Try adjusting your{' '}
            <Link onClick={onOpenPrimerSettings}>primer settings</Link>.
          </ErrorMessage>
        </div>
      );
    }
    default:
      return null;
  }
}

const styles = StyleSheet.create({
  messageContainer: {
    marginBottom: '10px',
  },
});
